var map = {
	"./customer.jsx": 50573,
	"./goods.jsx": 20951,
	"./industry.jsx": 76419,
	"./logistics.jsx": 88040,
	"./manage.jsx": 33212,
	"./order.jsx": 74261,
	"./robot.jsx": 36949,
	"./servicio.jsx": 36589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30890;